// src/components/dashboard/TopHeader/HeaderRight.js
import React from 'react';
import { useNavigate } from 'react-router-dom';  // ✅ Import useNavigate

function HeaderRight() {
  const navigate = useNavigate();  // ✅ Initialize navigate hook

  return (
    <div className="header-right">
     
      
      {/* ✅ COG ICON - Navigate to Settings */}
      <button 
        className="header-icon" 
        onClick={() => navigate('/settings')}
        title="Go to Settings"
        style={{ cursor: 'pointer' }}
      >
        <i className="fas fa-cog"></i>
      </button>
      
      
      <div className="user-avatar">
        <span>O</span>
      </div>
    </div>
  );
}

export default HeaderRight;